module.exports = "/static/images/menu-weddings.jpg";